import React from 'react'
import { useOutletContext } from 'react-router-dom'
import type { HistoryOutletContext } from './ModernHistoryLayout'
import HistoryAmbReport from './HistoryAmbReport'

/** หน้า รอผลการเล่นพนัน */
const HistoryPendingPage: React.FC = () => {
  useOutletContext<HistoryOutletContext>()
  return <HistoryAmbReport mode="pending" />
}

export default HistoryPendingPage
